<div class="additional-admin-features">
    <div class="row">
        <div class="head-component m-b-25">
            <div class="col-10 m-0 p-l-20 br-0 head-component for-fixed-component card">
                <div class="col-9 pl-0 card-body">
                    <div class="float-left">
                        <h5 class="m-0 head-main-component">
                            Additionally
                        </h5>
                        <div class="feature-route">
                            <span [routerLink]="['/admin/extra/assignment']" routerLinkActive="active-navigation" [class.filter-active]="targetTab === 'HR' ">Assign HR</span>
                            <span [routerLink]="['/admin/extra/feedback-manage']" routerLinkActive="active-navigation" [class.filter-active]="targetTab === 'feedback' ">Feedbacks</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
